import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { defineCustomElements } from "@ionic/pwa-elements/loader";

Sentry.init({
  dsn: "https://ba64d32cf290770e5bffffb9ead09251@o4509745783635968.ingest.de.sentry.io/4509746903056464",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", "https://maxipdfserver-eyh8g4a4cdghfma6.ukwest-01.azurewebsites.net", "https://construction.maxidev.uk"],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  // Logs
  enableLogs: true
});


// Bootstrap components
import "bootstrap/dist/css/bootstrap.min.css";



// Call the element loader before the render call
defineCustomElements(window);

const msalInstance = new PublicClientApplication(msalConfig);

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>
);
